//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import PurchaseOrderEditedModel from '@/models/Purchase/PchPurchaseOrderEdited'
import Translator from '@/services/translator'

//
import fields from './fields'

//
export default {
    name: 'purchase-order-create',
    components: {
        ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        currentEmployee() {
            return this.user.hr_employee
        },

        /**
         * @description
         * Form field props
         *
         * @return     {Object}  fields props object
         */
        fieldsProps() {
            return {
                g_branch_office_id: this.currentEmployee.g_branch_office_id,
                is_service: this.formData.is_service,
                pch_provider_id: this.formData.pch_provider_id,
            }
        },

        /**
         * @description
         */
        formProps() {
            return {
                fields: fields(this.fieldsProps),
            }
        },
    },
    data() {
        return {
            formData: new PurchaseOrderEditedModel({
                is_service: false,
                pch_provider_id: null,
            }),
            formDataSelected: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
        }),

        /**
         * @description
         */
        create(model) {
            model
                .toCreate()
                .save()
                .then(this.success)
                .then(this.redirect)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },

        /**
         * @description
         */
        redirect() {
            this.$router.push({ name: 'purchase-order-edited-list' })
        },

        /**
         * @description
         */
        reset() {
            //this.setFormData(new PurchaseOrderEditedModel())
        },

        /**
         *
         */
        selected({ name, selected }) {
            if (selected.length > 0 && name == 'pch_selected_purchase_order') {

                //
                this.formDataSelected = selected.slice().pop().reset()

                //
                this.formData.is_service = this.formDataSelected.is_service
                this.formData.pch_provider_id = this.formDataSelected.pch_provider_id
                this.formData.pch_purchase_order_id = this.formDataSelected.id
                this.formData.pch_selected_purchase_order_detail = this.formDataSelected.pch_selected_purchase_orders || []
                
                //
                this.formDataSelected.fetchProductServiceIndicator().then(this.setFormDataProductServiceIndicator)
            }
        },

        /**
         * @description
         */
        setFormData(model) {
            this.formData = model.reset()
        },

        /**
         * @description
         */
        setFormDataProductServiceIndicator() {
            console.log(this)
            this.formData.wh_product_service_indicator = this.formDataSelected.wh_product_service_indicator
        },

        /**
         * @description
         */
        error(error) {
            this.setErrorSnackbar(
                Translator(PurchaseOrderEditedModel, error.response.data)
            )
        },

        /**
         * @description
         */
        submit() {
            this.$refs.form.setWait(true).then(this.create)
        },

        /**
         * @description
         */
        success() {
            this.setSuccessSnackbar('Orden de compra creada exitosamente.')
        },
    },
    beforeMount() {
        this.setTitleTopBar('Editar orden de compra autorizada')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_EDITED_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
}
